import { render } from "./ConnectionSetup.vue?vue&type=template&id=3c232006&scoped=true"
import script from "./ConnectionSetup.vue?vue&type=script&lang=js"
export * from "./ConnectionSetup.vue?vue&type=script&lang=js"

import "./ConnectionSetup.vue?vue&type=style&index=0&id=3c232006&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c232006"]])

export default __exports__